module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Lausen_BL-805e1bea72af426f221c549235f906cf.svg";